import {
	AfterViewChecked,
	Component,
	Inject,
	Input,
	OnInit
} from '@angular/core';
import { constants, LiveChatUtilityService } from '@edassist/common';
import { DropdownService } from '@edassist-ui/dropdown';
import { DOCUMENT } from '@angular/common';

@Component({
	selector: 'ea-live-chat-button',
	templateUrl: './live-chat-button.component.html'
})

export class LiveChatButtonComponent implements OnInit, AfterViewChecked {
	@Input() buttonText: string;

	constructor(
		@Inject(DOCUMENT) private readonly document: Document,
		private readonly dropdownService: DropdownService,
		private readonly liveChatUtilityService: LiveChatUtilityService
	) {}

	loadChatWidget(): void {
		this.dropdownService.close(constants.dropdownIds.supportServices);
		this.liveChatUtilityService.showChatBox();
	}

	ngOnInit(): void {
		const chatWidget = this.document.getElementById('cl-chat-widget');
		if (chatWidget) {
			chatWidget.classList.remove('cl-hide');
		}
	}

	ngAfterViewChecked(): void {
		const chatWidget = this.document.getElementById('cl-chat-widget');
		if (chatWidget) {
			chatWidget.tabIndex = 0;

			const chatTabIndexElements = document.querySelectorAll<HTMLElement>(
				'#cl-chat-titlebar div[tabIndex]'
			);
			chatTabIndexElements.forEach((element) => {
				const item = element;
				item.tabIndex = 0;
			});
		}
	}
}
